"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
const subtasks_1 = require("../gql/subtasks");
class Subtask extends BaseModel_1.default {
    defaults() {
        return {
            uuid: '',
            title: '',
            checked: false,
            taskUuid: '',
        };
    }
    create() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(subtasks_1.createSubtaskMutation, yield this.prepareVariables()));
        });
    }
    update() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(subtasks_1.updateSubtaskMutation, yield this.prepareVariables()));
        });
    }
    delete() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(subtasks_1.deleteSubtaskMutation, {
                uuid: this.uuid,
            }));
        });
    }
    prepareVariables() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const subtask = yield this.getUpdateVariables();
            return {
                subtask,
            };
        });
    }
}
exports.default = Subtask;
//# sourceMappingURL=Subtask.js.map